// src/App.tsx
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useSearchParams } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider as MUIThemeProvider, CssBaseline } from "@mui/material";
import { ThemeProvider as SCThemeProvider } from "styled-components";
import { StyledEngineProvider } from "@mui/material/styles";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { GlobalStyle } from "./styles/GlobalStyle";
import { theme } from "./theme";

import AdminLayout from "src/layout/Layout";
import CustomSnackbar from "src/components/common/CustomSnackbar";

import DashboardPage from "src/pages/DashboardPage";
import LoginPage from "src/pages/LoginPage";
import LoginCallback from "src/pages/LoginCallback";
import CommonFaqPage from "src/pages/CommonFaqPage";
import NoticeManagePage from "src/pages/NoticeManagePage";
import CommonCodeManagePage from "src/pages/CommonCodeManagePage";
import TermsManagePage from "src/pages/TermsManagePage";
import NotFoundPage from "src/pages/NotFoundPage";
import ErrorPage from "src/pages/ErrorPage";
import SkuManagePage from "./pages/SkuManagePage";
import DelegateManagePage from "./pages/DelegateManagePage";

import { isAuthed } from "src/utils/tokenCookie";
import { useInitAuthCookie } from "src/hooks/useInitAuthCookie";
import BrandManagePage from "./pages/BrandManagePage";
import CollectionManagePage from "./pages/CollectionManagePage";

const queryClient = new QueryClient();

function ProtectedLayout() {
  // if (!isAuthed()) return <Navigate to="/login" replace />;
  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}

function LoginEntryRoute() {
  const [params] = useSearchParams();
  const code = params.get("code");

  // if (isAuthed()) return <Navigate to="/" replace />;
  if (code) return <LoginCallback />;
  return <LoginPage />;
}

function RootEntryRoute() {
  if (!isAuthed()) return <Navigate to="/login" replace />;
  return (
    <AdminLayout>
      <DashboardPage />
    </AdminLayout>
  );
}

export default function App() {
  const initialized = useInitAuthCookie();
  if (!initialized) return null; // ✅ 여기서 깜빡임/튕김 대부분 해결됨
  console.log(process.env.REACT_APP_OMS_SERVER_API);
  return (
    <QueryClientProvider client={queryClient}>
      <StyledEngineProvider injectFirst>
        <MUIThemeProvider theme={theme}>
          <SCThemeProvider theme={theme}>
            <CssBaseline />
            <GlobalStyle />
            <BrowserRouter>
              <Routes>
                <Route path="/login" element={<LoginEntryRoute />} />
                <Route path="/" element={<RootEntryRoute />} />

                <Route element={<ProtectedLayout />}>
                  <Route path="/common/notice" element={<NoticeManagePage />} />
                  <Route path="/common/faq" element={<CommonFaqPage />} />
                  <Route path="/common/terms" element={<TermsManagePage />} />
                  <Route path="/common/commonCode" element={<CommonCodeManagePage />} />
                  <Route path="/productManage/baseinfo/sku" element={<SkuManagePage />} />
                  <Route path="/delegate/manage" element={<DelegateManagePage />} />
                  <Route path="/common/brand" element={<BrandManagePage />} />
                  <Route path="/collection/manage" element={<CollectionManagePage />} />

                  <Route path="/error/404" element={<ErrorPage status={404} />} />
                  <Route path="/error/403" element={<ErrorPage status={403} />} />
                  <Route path="/error/500" element={<ErrorPage status={500} />} />
                </Route>

                <Route path="*" element={<NotFoundPage />} />
              </Routes>

              <CustomSnackbar />
            </BrowserRouter>

            <ReactQueryDevtools initialIsOpen={false} />
          </SCThemeProvider>
        </MUIThemeProvider>
      </StyledEngineProvider>
    </QueryClientProvider>
  );
}
